'use client';
import { useOption } from '@react-aria/listbox';
import e from 'prop-types';
import e__default, { useEffect } from 'react';
import { useTrackDisabledState } from '../../contexts/internal/collection/collection.context.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, o, t) {
    return o in e ? Object.defineProperty(e, o, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[o] = t, e;
}
function _object_spread(e) {
    for(var o = 1; o < arguments.length; o++){
        var t = null != arguments[o] ? arguments[o] : {}, r = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), r.forEach(function(o) {
            _define_property(e, o, t[o]);
        });
    }
    return e;
}
const propTypes = {
    disabled: e.bool,
    withThumbnail: e.bool,
    label: e.node,
    textValue: e.string
};
let l = Object.keys(propTypes);
const ListboxOptionInternal = ({ item: o, state: p })=>{
    var s;
    let a = e__default.useRef(null), { disabled: c } = null !== (s = o.props) && void 0 !== s ? s : {}, { optionProps: u, isFocused: d, isFocusVisible: b } = useOption(o, p, a);
    useTrackDisabledState(o.key, c);
    let f = e__default.useMemo(()=>{
        var e, o, t;
        return null === (t = window) || void 0 === t ? void 0 : null === (o = t.CSS) || void 0 === o ? void 0 : null === (e = o.supports) || void 0 === e ? void 0 : e.call(o, 'selector(:focus-visible)');
    }, []);
    useEffect(()=>{
        var e;
        null === (e = a.current) || void 0 === e || e.addEventListener('touchend', (e)=>{
            e.preventDefault();
        }, {
            passive: !1,
            once: !0
        });
    }, []);
    let m = new Set([
        'swan-listbox-option'
    ]);
    return o.props.withThumbnail && m.add('swan-listbox-option-with-thumbnail'), (f ? b : d) && m.add('swan-listbox-option-focused'), e__default.createElement(RenderComp, {
        root: "li",
        forwardedRef: a,
        propKeysToRemove: l,
        props: _object_spread({}, o.props, u),
        classNames: m
    }, o.rendered);
};

export { ListboxOptionInternal, propTypes };
